export class EmopTableProPageInfoClass {
  /**
   * 分页器是否可视
   */
  visible?: boolean = true;

  /**
   * 	当前页数
   */
  pageIndex?: number = 1;

  /**
   * 	每页条数
   */
  pageSize?: number = 10;

  /**
   * 每页的条数
   */
  pageSizeList?: number[] = [10, 20, 50];

  /**
   * 数据总数
   */
  total?: number = null;

  /**
   * 只有一页时是否隐藏分页器
   */
  hideOnSinglePage?: boolean = false;

  /**
   * 是否可以快速跳转至某页
   */
  showQuickJumper?: boolean = true;

  /**
   * 是否禁用
   */
  disabled?: boolean = false;

  /**
   * 分页器大小
   */
  size?: 'default' | 'small' = 'default';

  constructor(constructorData: EmopTableProPageInfoClass | true) {
    if (typeof constructorData !== 'boolean') {
      for (const key in constructorData) {
        if (constructorData[key] !== undefined) this[key] = constructorData[key];
      }
    }
  }
}